module.exports = __webpack_public_path__ + "01_very_short_yellow.35e92887.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_very_short_yellow.png
// module id = 8l8I
// module chunks = 0